import getBubbleSortAnnimations from "../SortingVisualizer/BubbbleSortAlgorithm";
import classes from "../SortingVisualizer/SortingVisualizer.module.css";
function backtonormal() {
  const resetbtn = document.getElementById("reset_btn");
  const inputs = document.getElementById("inputs");
  const quicksort = document.getElementById("QuickSort");
  const mergesort = document.getElementById("MergeSort");
  const bubblesort = document.getElementById("BubbleSort");
  const insertionsort = document.getElementById("InsertionSort");
  quicksort.classList.remove(`${classes.disable}`);
  mergesort.classList.remove(`${classes.disable}`);
  bubblesort.classList.remove(`${classes.selected}`);
  insertionsort.classList.remove(`${classes.disable}`);
  inputs.classList.remove(`${classes.disable}`);
  resetbtn.classList.remove(`${classes.disable}`);
}
export default function Bubblesort({ array, speed }) {
  const PRIMARY_COLOR = "blue";
  const SECONDRY_COLOR = "red";
  const annimations = getBubbleSortAnnimations(array);
  const ANNIMATION_S = Math.floor(200 - 5 * speed);
  for (let i = 0; i < annimations.length; i++) {
    const arrayBars = document.getElementsByClassName("array-bar");
    const [barOneIdx, barTwoIdx, height1, height2] = annimations[i];
    const barOneStyle = arrayBars[barOneIdx].style;
    const barTwostyle = arrayBars[barTwoIdx].style;

    setTimeout(() => {
      barOneStyle.backgroundColor = PRIMARY_COLOR;
      barOneStyle.height = `${height1}px`;
      setTimeout(() => {
        barOneStyle.backgroundColor = "turquoise";
      }, ANNIMATION_S);
    }, i * ANNIMATION_S);

    setTimeout(() => {
      barTwostyle.backgroundColor = SECONDRY_COLOR;
      barTwostyle.height = `${height2}px`;
      setTimeout(() => {
        barTwostyle.backgroundColor = "turquoise";
      }, ANNIMATION_S);

      if (i === annimations.length - 1) {
        backtonormal();
      }
    }, i * ANNIMATION_S);
  }
}
